import React from 'react'
import { translate, Trans } from 'react-i18next'

import LinkBlocksImg from '../components/LinkBlocksImg'
import ScrollToTopOnMount from '../components/ScrollToTopOnMount'

import ct2_1min from '../assets/img/create-tracks/compositions/ct2_1min-min.jpg'
import ct2_2min from '../assets/img/create-tracks/compositions/ct2_2min-min.jpg'
import ct2_3min from '../assets/img/create-tracks/compositions/ct2_3min-min.jpg'
import ct2_4min from '../assets/img/create-tracks/compositions/ct2_4min-min.jpg'
import ct2_5min from '../assets/img/create-tracks/compositions/ct2_5min-min.jpg'
import ct2_6min from '../assets/img/create-tracks/compositions/ct2_6min-min.jpg'


const T3_2 = (props) => {
  const arrImgmin = [ ct2_1min, ct2_2min, ct2_3min, ct2_4min, ct2_5min, ct2_6min ]
  const arrImgfull = [
    { src: process.env.PUBLIC_URL + '/assets/ct2_1.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/ct2_2.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/ct2_3.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/ct2_4.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/ct2_5.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/ct2_6.jpg'}
  ]
  return(
    <LinkBlocksImg itemsmin={arrImgmin} itemsfull={arrImgfull} url='/create-tracks' >
      <ScrollToTopOnMount />
      <Trans i18nKey='T3_2'>
        <p>
          Як художник малює картину, так і фітодизайнер створює композицію з кімнатних рослин.
        </p>
        <p>
          Підбір різних за кольором та фактурою рослин з додаванням природніх матеріалів, вибір відповідного горщика або кашпо – це все дає змогу фітодизайнеру створити власну фітокомпозицію – картину, яка немає повторень.
        </p>
        <p>
          Завдяки такому поєднанню живих рослин легко підкреслити індивідуальність, стильність і неповторність дизайну інтер’єру, розставити акценти та виконати зонування простору.
        </p>
        <p className="prise">
          Вартість композиції з кімнатних рослин починається від 500 грн та залежить від вибору розмірів, кількості та виду квітів, а також від вибору кашпо і декору.
        </p>
      </Trans>
    </LinkBlocksImg>
  )
}

export default translate('translations')(T3_2)


// WEBPACK FOOTER //
// ./src/page/T3_2.jsx